import Navbar from "../components/Navbar";
import {
  FaWhatsapp,
  FaInstagram,
  FaLinkedin,
  FaFacebook,
  FaEnvelope,
  FaPhoneAlt,
} from "react-icons/fa";

export default function ServiciosForm() {
  return (
    <div className="min-h-screen flex flex-col bg-[#1f1b24] text-white font-nexa font-normal">
      {/* ===== NAVBAR ===== */}
      <Navbar />

      {/* ===== CONTENIDO PRINCIPAL ===== */}
      <main className="flex-grow max-w-5xl mx-auto px-6 md:px-12 py-16">
        {/* Título principal */}
        <div className="flex justify-start mb-12">
          <div
            className="inline-block text-[#1f1b24] font-extrabold text-2xl md:text-3xl px-8 py-4 rounded-2xl shadow-lg"
            style={{
              background: "linear-gradient(90deg, #00b3b3, #00e68a)",
            }}
          >
            Servicios QuarkIA
          </div>
        </div>

        {/* ===== 2.1 ===== */}
        <h2 className="text-[#00e68a] font-bold text-xl md:text-2xl mb-4">
          Plataformas de información para el sector energético
        </h2>
        <p className="text-lg leading-relaxed text-justify mb-4">
          Diseñamos y desarrollamos plataformas digitales que integran, estructuran y visualizan datos públicos del sector energético en entornos claros, accesibles y listos para su análisis.
        </p>
        <p className="text-lg leading-relaxed text-justify mb-10">
          Estas soluciones permiten a las organizaciones centralizar su información, mejorar su gestión y facilitar el aprovechamiento de datos dentro de sus procesos internos.
        </p>

        {/* ===== 2.2 ===== */}
        <h2 className="text-[#00e68a] font-bold text-xl md:text-2xl mb-4">
          Modelos analíticos e inteligencia artificial
        </h2>
        <p className="text-lg leading-relaxed text-justify mb-4">
          Desarrollamos modelos analíticos y soluciones basadas en inteligencia artificial a partir de datos abiertos, orientados a la generación de escenarios y simulaciones que permiten explorar el comportamiento de variables del sector energético.
        </p>
        <p className="text-lg leading-relaxed text-justify mb-10">
          Estas herramientas facilitan el análisis técnico de la información y fortalecen las capacidades internas de las organizaciones para trabajar con datos de manera estructurada.
        </p>

        {/* ===== 2.3 ===== */}
        <h2 className="text-[#00e68a] font-bold text-xl md:text-2xl mb-4">
          Soluciones basadas en datos
        </h2>
        <p className="text-lg leading-relaxed text-justify mb-4">
          Acompañamos a las organizaciones en la estructuración de iniciativas orientadas al aprovechamiento de datos, mediante el diseño de arquitecturas de información, integración de fuentes y desarrollo de capacidades analíticas.
        </p>
        <p className="text-lg leading-relaxed text-justify mb-10">
          Nuestro enfoque permite transformar los datos en activos operativos dentro de la organización.
        </p>

        {/* ===== 2.4 ===== */}
        <h2 className="text-[#00e68a] font-bold text-xl md:text-2xl mb-4">
          Automatización de procesos
        </h2>
        <p className="text-lg leading-relaxed text-justify mb-4">
          Implementamos soluciones tecnológicas que automatizan el manejo y procesamiento de información, reduciendo tareas manuales y mejorando la eficiencia operativa.
        </p>
        <p className="text-lg leading-relaxed text-justify mb-10">
          Esto permite optimizar flujos de trabajo y liberar tiempo para actividades de mayor valor analítico.
        </p>

        {/* ===== 2.5 ===== */}
        <h2 className="text-[#00e68a] font-bold text-xl md:text-2xl mb-4">
          Desarrollo de herramientas digitales a la medida
        </h2>
        <p className="text-lg leading-relaxed text-justify mb-4">
          Creamos herramientas tecnológicas adaptadas a necesidades específicas, enfocadas en el procesamiento, análisis y visualización de datos.
        </p>
        <p className="text-lg leading-relaxed text-justify mb-10">
          Nuestras soluciones son modulares, escalables y diseñadas para integrarse con los sistemas existentes de cada organización.
        </p>
      </main>

      {/* ======= FOOTER ======= */}
      <footer className="bg-[#16131a] py-8 text-center border-t border-gray-700">
        <div className="flex flex-col items-center space-y-4">
          <div className="flex space-x-6 text-2xl text-[#00b3b3]">
            <a
              href="https://wa.me/573001234567"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-[#00ff80] transition"
            >
              <FaWhatsapp />
            </a>
            <a
              href="https://www.instagram.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-[#00ff80] transition"
            >
              <FaInstagram />
            </a>
            <a
              href="https://www.linkedin.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-[#00ff80] transition"
            >
              <FaLinkedin />
            </a>
            <a
              href="https://www.facebook.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-[#00ff80] transition"
            >
              <FaFacebook />
            </a>
          </div>

          {/* 📧 y 📞 */}
          <div className="flex flex-col items-center text-sm md:text-base space-y-2">
            <p className="flex items-center space-x-2">
              <FaEnvelope className="text-[#00b3b3]" />
              <span>info@quarkia.com.co</span>
            </p>
            <p className="flex items-center space-x-2">
              <FaPhoneAlt className="text-[#00b3b3]" />
              <span>+57 311 383 6855</span>
            </p>
          </div>

          <p className="text-gray-400 text-xs mt-4">
            © {new Date().getFullYear()} QuarkIA S.A.S. All rights reserved.
          </p>
        </div>
      </footer>
    </div>
  );
}
